import service from './axios';

// 旅拍套餐相关API
export const getPhotoPackages = (params = {}) => {
  return service({
    url: '/manage/photo-packages',
    method: 'get',
    params
  });
};

export const getPhotoPackageById = (id) => {
  return service({
    url: `/manage/photo-packages/${id}`,
    method: 'get'
  });
};

export const createPhotoPackage = (data) => {
  return service({
    url: '/manage/photo-packages',
    method: 'post',
    data
  });
};

export const updatePhotoPackage = (id, data) => {
  return service({
    url: `/manage/photo-packages/${id}`,
    method: 'put',
    data
  });
};

export const deletePhotoPackage = (id) => {
  return service({
    url: `/manage/photo-packages/${id}`,
    method: 'delete'
  });
};

// 旅拍咨询相关API
export const getPhotoConsultations = (params = {}) => {
  return service({
    url: '/manage/photo-consultations',
    method: 'get',
    params
  });
};

export const getPhotoConsultationById = (id) => {
  return service({
    url: `/manage/photo-consultations/${id}`,
    method: 'get'
  });
};

export const updatePhotoConsultation = (id, data) => {
  return service({
    url: `/manage/photo-consultations/${id}`,
    method: 'put',
    data
  });
};

export const deletePhotoConsultation = (id) => {
  return service({
    url: `/manage/photo-consultations/${id}`,
    method: 'delete'
  });
};
